<template>
  <footer class="footer">
    <div class="upper container">
      <div class="footer_col one">
        <a href="/" class="brand"
          ><img
            :src="parsedGlobalSettings.footer.footer_logo.url"
            alt="DCS"
            height="50"
        /></a>

        <div class="about" v-html="parsedGlobalSettings.footer.address"></div>
      </div>

      <div class="footer_col two">
        <div class="inner">
          <ul class="footer-menu">
            <li v-for="(menu_item, index) in parsedMainMenu" :key="index">
              <a
                :href="menu_item.url"
                :target="menu_item.target"
                v-html="menu_item.title"
              ></a>
            </li>
          </ul>

          <h3
            class="col_header"
            v-if="parsedGlobalSettings.footer.column_heading_2"
            v-html="parsedGlobalSettings.footer.column_heading_2"
          ></h3>
          <div
            class="contact"
            v-html="parsedGlobalSettings.footer.contact"
          ></div>
          <primary-button
            v-if="parsedGlobalSettings.general.cta"
            :link="parsedGlobalSettings.general.cta"
            :label="parsedGlobalSettings.general.cta.title"
            :theme="'yellow'"
            :target="parsedGlobalSettings.general.cta.target"
          ></primary-button>
        </div>
      </div>
    </div>
    <div class="lower container">
      <div class="inner">
        <div class="copyright">
          <span class="copyright"
            >&copy; {{ getTheYear }} Diesel Cleaning Solutions. All Rights
            Reserved.</span
          >
        </div>

        <div class="footer-menu-wrapper">
          <ul class="footer-menu">
            <li v-for="(menu_item, index) in parsedFooterMenu" :key="index">
              <a
                :href="menu_item.url"
                :target="menu_item.target"
                v-html="menu_item.title"
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import PrimaryButton from '../vue/PrimaryButton.vue';

export default {
  data() {
    return {};
  },

  props: {
    footer_menu: {},
    main_menu: {},
    currentId: {
      type: Number,
      default: -1,
    },
    global_settings: {},
    asset_url: {},
    built_by: {},
    privacy_policy: {},
    cookieOptions: {},
  },

  computed: {
    parsedGlobalSettings() {
      if (this.global_settings) {
        return JSON.parse(this.global_settings);
      } else {
        return null;
      }
    },

    cookieExpiry() {
      // var now = new Date();
      // var time = now.getTime();
      // time += 3600 * 1000;
      // now.setTime(time);

      return {
        'max-age': 30 * 24 * 60 * 60,
      };
    },

    parsedFooterMenu() {
      if (this.footer_menu) {
        return JSON.parse(this.footer_menu);
      } else {
        return null;
      }
    },

    parsedMainMenu() {
      if (this.main_menu) {
        return JSON.parse(this.main_menu);
      } else {
        return null;
      }
    },

    getTheYear() {
      var d = new Date();
      var n = d.getFullYear();
      return n;
    },
  },

  watch: {},

  methods: {
    getFullUrl(arg) {
      let assetUrl = this.asset_url;
      return assetUrl + arg + '.svg';
    },
  },

  components: {
    PrimaryButton,
  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
  padding: 50px 0;
  background: var(--dark-purple);
  overflow: hidden;

  @media (max-width: $mobile-xl) {
    padding: 32px 0;
  }

  .upper {
    @media (max-width: $mobile-xl) {
      row-gap: 32px;
      margin-bottom: 32px;
    }

    &.container {
      column-gap: 24px;
    }

    .footer_col {
      grid-column: span 6;
      color: var(--white);

      @media (max-width: $mobile-xl) {
        grid-column: span 4;
        padding: 0 var(--gutter-tablet-desktop);
      }

      .brand {
        width: 100%;
        display: flex;

        @media (max-width: $mobile-xl) {
          justify-content: flex-start;
        }

        img {
          height: 48px;

          /* @media (max-width: $mobile-xl) {
						height: 48px;
					} */
        }
      }

      &::v-deep {
        h4 {
          margin: 0 0 24px;
          color: var(--white);

          @media (max-width: $mobile-xl) {
            font: normal normal bold 20px/24px var(--primary-font-family);
          }
        }

        h3 {
          color: var(--white);
          font: normal normal 600 var(--body-font-size)
            var(--primary-font-family);
          text-transform: unset;
          margin: 0 0 24px;
        }

        p {
          font: normal normal normal 12px/14px var(--primary-font-family);
        }

        a {
          color: var(--white);
          font: normal normal normal 12px/14px var(--primary-font-family);
          text-decoration: none;
        }
      }

      &.one {
        grid-column: span 6;

        @media (max-width: $mobile-xl) {
          grid-column: span 4;
          padding: 0;
        }

        .about {
          margin-top: 40px;

          &::v-deep {
            p {
              margin: 16px 0 0;
            }
          }
        }
      }

      &.two {
        grid-column: span 6;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;

        @media (max-width: $mobile-xl) {
          grid-column: span 4;
          padding: 0;
        }

        ul:not(.footer-menu) {
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: row;
          row-gap: 0;
          list-style: none;
          gap: 16px;

          /* &::v-deep {
						li {
							padding: 16px 0;
							border-bottom: 1.5px solid var(--white);

							div {
								padding: 0;

								a {
									color: var(--white);
									font: normal normal normal 14px/20px
										var(--primary-font-family);
								}
							}

							&.last {
								padding-bottom: 0;
								// margin-bottom: 32px;
								border-bottom: unset;

								div {
									padding: 0;
								}
							}
						}
					} */
        }

        .inner {
          width: 300px;

          @media (max-width: $mobile-xl) {
            width: 100%;
          }
        }
      }
    }
  }

	.contact {
		margin-bottom: 20px;
	}

  .lower {
    margin-top: 75px;

    @media (max-width: $mobile-xl) {
      margin-top: 16px;
    }

    .inner {
      grid-column: span 12;
      display: flex;
      justify-content: space-between;
      gap: 24px;

      @media (max-width: $mobile-xl) {
        grid-column: span 4;
        display: flex;
        flex-direction: column-reverse;
        gap: 24px;
      }

      .copyright {
        grid-column: span 1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 8px;
        color: var(--white);

        @media (max-width: $mobile-xl) {
          grid-column: span 4;
          justify-content: flex-start;
        }

        &::v-deep {
          p,
          span {
            color: var(--white);
            font: normal normal normal 12px/14px var(--primary-font-family);
          }
        }

        .menu_item__parent {
          &::v-deep {
            > div {
              padding: 0;
            }
          }
        }
      }

      .menu_item__parent {
        grid-column: span 1;
        justify-content: flex-end;

        @media (max-width: $mobile-xl) {
          grid-column: span 4;
          justify-content: center;
        }

        &::v-deep {
          .menu_item__parent__primary_link {
            font: normal normal normal 12px/14px var(--primary-font-family);
          }

          > div {
            padding: 0;
          }
        }
      }
    }
  }

  .footer-menu {
    display: flex;
    flex-direction: column;
    padding: 0;
    list-style: none;

    > li {
      a {
        color: var(--white);
        font: normal normal normal 12px/14px var(--primary-font-family);
        text-decoration: none;
        display: flex;
      }
    }

    &-wrapper {
      width: 300px;

      @media (max-width: $mobile-xl) {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue